
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_f05884749a7ee4e7596872099565edf7_c3568f71.jpg"
          alt="Grand Luxury Beauty Store Interior"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full px-8 py-32 h-screen flex items-end">
        <div className="max-w-7xl mx-auto w-full">
          <div className="w-full flex flex-col items-center text-center pb-16">
            <p className="text-rose-300 text-sm tracking-widest uppercase mb-6 font-light">Retail Store Builder · Beauty &amp; Skincare Specialists</p>
            <h1 className="font-serif font-bold text-white leading-tight mb-10" style={{ fontSize: '100px', lineHeight: '1.1' }}>
              Mount Zion<br />
              <span className="text-rose-300">Investment INC</span>
            </h1>

            <p className="text-gray-200 text-base font-light mb-16 max-w-xl">
              Building premium beauty &amp; skincare retail stores — from concept to grand opening. We create stunning boutique experiences that sell.
            </p>

            <div className="flex items-center gap-4">
              <button className="bg-rose-500 text-white px-12 py-4 rounded-full text-base font-medium hover:bg-rose-600 transition-all flex items-center gap-3 whitespace-nowrap cursor-pointer group">
                Explore Our Stores
                <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
              </button>
              <button className="border border-white text-white px-12 py-4 rounded-full text-base font-medium hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer">
                Build With Us
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
